import { useEffect } from 'react';

// Appends a <script type="application/ld+json"> with the given schema to <head>
// for the lifetime of the component (no-op if an element with that id exists).
export const useJsonLdScript = (id, schema) => {
  useEffect(() => {
    if (document.getElementById(id)) return undefined;
    const ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.id = id;
    ld.text = JSON.stringify(schema);
    document.head.appendChild(ld);
    return () => document.getElementById(id)?.remove();
  }, [id, schema]);
};
